export default __webpack_public_path__ + "34f5f5ea9672f0fe425262fffbcb3ebf.jpg";